import { render, staticRenderFns } from "./MaterialLIst.vue?vue&type=template&id=16637008&"
import script from "./MaterialLIst.vue?vue&type=script&lang=js&"
export * from "./MaterialLIst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports